module.exports = __webpack_public_path__ + "img/1-2.0824711b.svg";